export interface Skill {
  name: string
  proficiency: number
}

export const skills: Skill[] = [
  { name: 'JavaScript', proficiency: 80 },
  { name: 'TypeScript', proficiency: 75 },
  { name: 'React', proficiency: 70 },
  { name: 'AngularJS', proficiency: 70 },
  { name: 'Node.js', proficiency: 70 },
  { name: 'Express', proficiency: 65 },
  { name: 'MongoDB', proficiency: 65 },
  { name: 'Microsoft SQL Server', proficiency: 65 },
  { name: 'SQLite', proficiency: 60 },
  { name: 'Tailwind CSS', proficiency: 65 },
  { name: 'Vite', proficiency: 65 },
  { name: 'jQuery', proficiency: 70 },
  { name: 'ASP.NET MVC', proficiency: 60 },
  { name: 'Git', proficiency: 70 },
  { name: 'GitHub', proficiency: 70 },
]

export default skills
